import { DataType } from '../enums/data-type';
/** 前端数据类型定义转换为后端数据类型定义 */
export const DATA_TYPE_TO_FIELD_MAP = {
    [DataType.PATENT]: 'PATENT',
    [DataType.PAPER]: 'PAPER',
    [DataType.MARKET]: 'MR',
    [DataType.INVESTMENT]: 'VC',
    [DataType.MERGER]: 'MA',
    [DataType.BIO]: 'BIO',
    [DataType.DRUG]: 'DRUG',
    [DataType.CLINICAL]: 'CLINICAL',
    [DataType.CLINICAL_RESULT]: 'CLINICAL_RESULT',
};
